import { Link } from "react-router-dom";
import { Diamond, MapPin, Wine, Crown } from "lucide-react";

const ARTICLES = [
  {
    slug: "best-vip-escort-agency-athens",
    icon: Crown,
    title: "Why Billion Euro Babies Is the Best VIP Escort Agency in Athens",
    excerpt:
      "From the marble lobbies of Kolonaki to the seafront suites of Glyfada, Athens has always rewarded those who travel in style. Billion Euro Babies brings together the city's most refined VIP companions — verified, multilingual and discreet.",
    body: [
      "Athens in 2026 is a city of contrasts: ancient stone, modern luxury, midnight skylines and rooftop pools overlooking the Acropolis. The clientele has grown more international, more sophisticated, and more demanding. At Billion Euro Babies we curate a private circle of VIP escort companions whose presence elevates every occasion — gala dinners, private yachts in Piraeus, weekend escapes to Mykonos, or quiet evenings in a Kifisia villa.",
      "What sets us apart from any other escort agency in Athens is our verification standard. Every model is photographed in studio, every age and identity confirmed, every booking handled by a single point of contact. There are no surprises, no missed connections, no compromised discretion. This is the highest tier of the Athens escort scene.",
      "Our companions speak English, Greek, Russian and Spanish. They understand etiquette in five-star hotels and fluency in conversation across business, art, fashion and travel. Whether you require GFE, dinner date company, an overnight companion or a multi-day travel partner, Billion Euro Babies delivers the most refined VIP escort service in Athens, Greece.",
    ],
  },
  {
    slug: "outcall-escort-athens-glyfada-kifisia",
    icon: MapPin,
    title: "Outcall Escort Service in Athens, Glyfada, Kifisia & Piraeus",
    excerpt:
      "Outcall-only means complete discretion. Our verified VIP companions visit you at your hotel, villa or apartment across Greater Athens — Glyfada, Kifisia, Piraeus, Kolonaki and the entire Athenian Riviera.",
    body: [
      "An outcall escort service in Athens is, for most clients, the only acceptable arrangement. You stay in your own environment — a hotel suite at the Grande Bretagne, a private apartment in Kolonaki, a holiday villa on the Athens Riviera — and a verified VIP companion arrives at the agreed time. No anonymous addresses, no shared incall apartments, no compromise on privacy.",
      "Billion Euro Babies operates exclusively as an outcall escort agency. Our companions cover the entire Attica region: central Athens, Plaka, Kolonaki, Kifisia, Glyfada, Voula, Vouliagmeni, Piraeus, and on request any of the seaside resorts of the Athens Riviera. Travel time is built into the rate; transport is private.",
      "Booking is simple. WhatsApp or call our concierge at +30 6944 909 006, select the model that interests you, confirm the duration (30 minutes to 8 hours, with overnight and multi-day options), and the companion is on her way. For longer commitments — yacht charters, weekend stays in Mykonos or Santorini, business travel across Europe — please give at least 48 hours notice.",
    ],
  },
  {
    slug: "athens-luxury-companions-dinner-dates",
    icon: Wine,
    title: "Luxury Dinner Date Companions in Athens — Where the Elite Eat",
    excerpt:
      "Athens has Michelin-starred restaurants, rooftop bars with Acropolis views, and discreet seafood tavernas in Vouliagmeni. Our dinner-date companions know each one — and how to be remembered for the right reasons.",
    body: [
      "A dinner date in Athens is more than a meal. It is a curated evening that begins with the right reservation — Spondi for fine French, Hytra for modern Greek, Varoulko at the Piraeus marina, or 360 Cocktail Bar overlooking the Parthenon at sunset — and continues with conversation that lingers long after dessert.",
      "Our VIP companions are chosen not only for their beauty but for their fluency in the rituals of luxury. They understand wine lists, dress for the room, speak with the staff in flawless Greek or English, and turn heads without ever drawing the wrong kind of attention.",
      "Book a dinner date companion from Billion Euro Babies for an evening of refined company in the most exclusive venues in Athens. We can pre-book the restaurant, arrange a private driver, and ensure your evening flows seamlessly from cocktails to the final goodnight.",
    ],
  },
];

export default function Blog() {
  return (
    <div className="pt-32 pb-28 px-6 md:px-12" data-testid="blog-page">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-center mb-20">
          <Diamond size={20} className="text-[var(--gold)] mx-auto mb-6 gold-pulse" />
          <div className="label-luxury mb-4">Journal · Athens Insights</div>
          <h1 className="font-serif-display text-5xl md:text-7xl font-light tracking-tight">
            The <span className="italic gold-text">Athens VIP</span> Guide
          </h1>
          <p className="text-white/60 mt-6 max-w-2xl mx-auto">
            Insider notes on luxury, discretion and refined company in Greece&apos;s most sophisticated city.
          </p>
        </div>

        <div className="space-y-16">
          {ARTICLES.map((a) => {
            const Icon = a.icon;
            return (
              <article
                key={a.slug}
                id={a.slug}
                className="border-t border-white/10 pt-12"
                data-testid={`article-${a.slug}`}
              >
                <div className="flex items-start gap-6 mb-6">
                  <div className="hidden md:flex items-center justify-center w-14 h-14 border border-[var(--gold)]/40 text-[var(--gold)] shrink-0">
                    <Icon size={20} />
                  </div>
                  <div>
                    <h2 className="font-serif-display text-3xl md:text-5xl font-light leading-[1.1]">
                      {a.title}
                    </h2>
                    <p className="text-white/70 mt-5 text-lg max-w-3xl">{a.excerpt}</p>
                  </div>
                </div>
                <div className="space-y-5 mt-8 max-w-3xl text-white/65 leading-relaxed">
                  {a.body.map((p) => (
                    <p key={p.slice(0, 40)}>{p}</p>
                  ))}
                </div>
              </article>
            );
          })}
        </div>

        <div className="text-center mt-24 border-t border-white/10 pt-16">
          <h3 className="font-serif-display text-3xl md:text-4xl mb-6">
            Ready to <span className="italic gold-text">begin your evening?</span>
          </h3>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/companions" className="btn-gold btn-gold-solid" data-testid="blog-cta-companions">
              View Companions
            </Link>
            <Link to="/contact" className="btn-gold" data-testid="blog-cta-contact">
              Arrange an Evening
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
